import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useReportCardService } from "../apis/reportCard/useReportCardService";
import type { TUpdateConfigRequest } from "../apis/reportCard/reportCard.interfaces";
import { useInstituteContext } from "../context/institute.context";

export const useReportCardTemplatesHook = () => {
  const { getTemplates } = useReportCardService();
  const { selectedInstitute } = useInstituteContext();

  return useQuery({
    queryKey: ["report-card-templates", selectedInstitute?.id],
    queryFn: () => getTemplates(),
    enabled: !!selectedInstitute?.id,
    staleTime: 5 * 60 * 1000,
  });
};

export const useReportCardConfigHook = () => {
  const { getConfig } = useReportCardService();
  const { selectedInstitute } = useInstituteContext();

  return useQuery({
    queryKey: ["report-card-config", selectedInstitute?.id],
    queryFn: () => getConfig(),
    enabled: !!selectedInstitute?.id,
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateReportCardConfigHook = () => {
  const { updateConfig } = useReportCardService();
  const queryClient = useQueryClient();
  const { selectedInstitute } = useInstituteContext();

  return useMutation({
    mutationFn: (request: TUpdateConfigRequest) => updateConfig(request),
    onSuccess: () => {
      const id = selectedInstitute?.id;
      queryClient.invalidateQueries({ queryKey: ["report-card-templates", id] });
      queryClient.invalidateQueries({ queryKey: ["report-card-config", id] });
    },
  });
};
